import {ModalBase} from '../ModalBase'

const ModalConfirm = (props: any) => {
  return (
    <ModalBase Styles={props.Styles}>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{props.title}</h3>
          </div>
          <div className='form-separator'></div>
          <p className='m'>{props.detail}</p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            {props.closeModalConfirm &&
              <button className='m button transparent w-inline-block' onClick={props.closeModalConfirm}>
                <div>{props.messageClose || 'Cancelar'}</div>
              </button>
            }
            <button className='m button w-inline-block' onClick={props.actionConfirm}>
              <div>{props.messageAction || 'Confirmar'}</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalConfirm
